import { parse, theme } from "@config/theme";
import { css } from "linaria";
export const container = parse({
  position: "relative"
}, "c1rof3ab");
export const track = parse({
  position: "absolute",
  width: "100%",
  height: "100%"
}, "t1ibq9pj");

require("./styles.linaria.module.css!=!../../../../node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./styles.ts");